"use strict";

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationItemDropdown = void 0;

var _react = _interopRequireDefault(require("react"));

var _NavigationItem = require("./NavigationItem");

var _List = require("../List");

var _ListItemText = require("../ListItemText");

var _NestedListContainer = require("../NestedListContainer");

var _AnimatedNavigationItemBorder = require("./AnimatedNavigationItemBorder");

var _utils = require("../../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var NavigationItemDropdown = function NavigationItemDropdown(_ref) {
  var _ref$data = _ref.data,
      route = _ref$data.route,
      activeRouteKey = _ref$data.activeRouteKey,
      _onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;
  return _react["default"].createElement(_NavigationItem.NavigationItem, _extends({
    key: route.key,
    onMouseEnter: function onMouseEnter() {
      return _onMouseEnter(route.key);
    },
    onMouseLeave: onMouseLeave,
    data: route
  }, route, route.navigationItemProps), route.iconPosition && route.iconPosition === _utils.factory.ICON_POSITION.LEFT && route.icon, _react["default"].createElement(_ListItemText.ListItemText, null, route.label), route.iconPosition && route.iconPosition === _utils.factory.ICON_POSITION.RIGHT && route.icon, _react["default"].createElement(_AnimatedNavigationItemBorder.AnimatedNavigationItemBorder, {
    active: activeRouteKey === route.key
  }), _react["default"].createElement(_NestedListContainer.NestedListContainer, {
    active: activeRouteKey === route.key
  }, _react["default"].createElement(_List.List, {
    position: "absolute",
    overflow: "auto",
    minWidth: "160px",
    left: "0",
    boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
    borderRadius: "0px 0px 15px 15px",
    bg: "white",
    zIndex: "1",
    mt: "17px",
    width: "240px"
  }, Array.isArray(route.subRoutes) && route.subRoutes.map(function (subRoute) {
    return _react["default"].createElement(_NavigationItem.NavigationItem, _extends({
      key: subRoute.key,
      px: "20px",
      mx: 0,
      height: "60px",
      alignItems: "center",
      hoverBackground: "rgb(0, 191, 143)",
      hoverColor: "white",
      data: subRoute
    }, subRoute), _react["default"].createElement(_ListItemText.ListItemText, null, subRoute.label));
  }))));
};

exports.NavigationItemDropdown = NavigationItemDropdown;